"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salo": {
    "565c3d35": [{
      "hkey": "7cebcc13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "campoverde": [{
      "hkey": "7cebcc13",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "salo"
    }],
    "9584195a": [{
      "hkey": "e70a696f",
      "slug": "cunettone-villa",
      "name": "Cunettone-Villa",
      "primary": true,
      "skipSearch": false
    }],
    "cunettone": [{
      "hkey": "e70a696f",
      "slug": "cunettone-villa",
      "name": "Cunettone-Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "71142eaf": [{
      "hkey": "e70a696f",
      "slug": "cunettone-villa",
      "name": "Cunettone-Villa",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "e70a696f",
      "slug": "cunettone-villa",
      "name": "Cunettone-Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "salo"
    }]
  }
};
exports["default"] = _default;